import { ApolloProvider } from '@apollo/client'
import { graphql } from 'gatsby'
import React, { useEffect } from 'react'
import { ToolOverlayProvider } from '../components/Context/ToolOverlayContext'
import Layout from '../components/base/Layout'
import Seo from '../components/base/Seo'
import ContentBlocks from '../components/organisms/ContentBlocks'
import { apolloClient } from '../services/apollo'

const Page = ({
  data: {
    craftContent: { page },
  },
  pageContext: { alternates },
}) => {
  useEffect(() => {
    const smoothScrollAnchors = document.querySelectorAll('a[href^="#"]')
    smoothScrollAnchors.forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault()

        const target = document.querySelector(this.getAttribute('href'))

        target.scrollIntoView({
          behavior: 'smooth',
          block: 'start',
        })

        window.history.pushState(null, null, this.getAttribute('href'))
      })
    })
  }, [])

  const content = (
    <>
      <Seo seomatic={page.seomatic} hreflangs={alternates} />

      <ContentBlocks contentBlocks={page.contentBlocks} />
    </>
  )

  if (page.layoutFullscreen) {
    return content
  }

  return (
    <ToolOverlayProvider>
      <ApolloProvider client={apolloClient}>
        <Layout
          headerVariant={page.headerVariant}
          invertedHeader={page.invertedHeader}
          alternates={alternates}
        >
          {content}
        </Layout>
      </ApolloProvider>
    </ToolOverlayProvider>
  )
}

export const pageQuery = graphql`
  query PageQuery(
    $id: [CraftContent_QueryArgument]
    $siteId: [CraftContent_QueryArgument]
  ) {
    craftContent {
      page: entry(id: $id, siteId: $siteId) {
        ... on CraftContent_page_default_Entry {
          seomatic(asArray: true) {
            metaTitleContainer
            metaTagContainer
          }
          title
          invertedHeader
          headerVariant
          layoutFullscreen
          contentBlocks {
            __typename
            ... on CraftContent_contentBlocks_hero_BlockType {
              id
              ...heroBlockType
            }
            ... on CraftContent_contentBlocks_headerAlternative_BlockType {
              id
              ...headerAlternativeBlockType
            }
            ... on CraftContent_contentBlocks_testimonial_BlockType {
              id
              quote
              author
              photo {
                url
              }
            }
            ... on CraftContent_contentBlocks_serviceSection_BlockType {
              id
              ...serviceSectionBlockType
            }
            ... on CraftContent_contentBlocks_careersFeature_BlockType {
              id
              ...careersFeatureBlockType
            }
            ... on CraftContent_contentBlocks_magazinePage_BlockType {
              id
              liftStoriesName
            }
            ... on CraftContent_contentBlocks_twoColumnTeaserSection_BlockType {
              id
              ...twoColumnTeaserSectionBlockType
            }
            ... on CraftContent_contentBlocks_referencesSliderNew_BlockType {
              id
              ...referencesSliderNewBlockType
            }
            ... on CraftContent_contentBlocks_lightboxDetails_BlockType {
              id
              ...lightboxDetailsBlockType
            }
            ... on CraftContent_contentBlocks_boxRotator_BlockType {
              id
              ...boxRotatorBlockType
            }
            ... on CraftContent_contentBlocks_mediaContainer_BlockType {
              id
              ...mediaContainerBlockType
            }
            ... on CraftContent_contentBlocks_advantagesDisadvantages_BlockType {
              id
              ...advantagesDisadvantagesBlockType
            }
            ... on CraftContent_contentBlocks_table_BlockType {
              id
              ...tableBlockType
            }
            ... on CraftContent_contentBlocks_harmonica_BlockType {
              id
              ...harmonicaBlockType
            }
            ... on CraftContent_contentBlocks_copy_BlockType {
              id
              ...copyBlockType
            }
            ... on CraftContent_contentBlocks_jobsList_BlockType {
              id
              ...jobsListBlockType
            }
            ... on CraftContent_contentBlocks_peopleList_BlockType {
              id
              ...peopleListBlockType
            }
            ... on CraftContent_contentBlocks_teaserLift_BlockType {
              id
              ...teaserLiftBlockType
            }
            ... on CraftContent_contentBlocks_cardsSection_BlockType {
              id
              ...cardsSectionBlockType
            }
            ... on CraftContent_contentBlocks_colors_BlockType {
              id
              ...colorsBlockType
            }
            ... on CraftContent_contentBlocks_m14Renovation_BlockType {
              id
              ...renovationBlockType
            }
            ... on CraftContent_contentBlocks_liftConfigurator_BlockType {
              id
              ...liftConfiguratorBlockType
            }
            ... on CraftContent_contentBlocks_formBuilder_BlockType {
              id
              ...formBuilderBlockType
            }
            ... on CraftContent_contentBlocks_jobListAbstract_BlockType {
              id
              ...jobListAbstractSectionBlockType
            }
            ... on CraftContent_contentBlocks_hubSpotForm_BlockType {
              id
              ...hubSpotFormSectionBlockType
            }
            ... on CraftContent_contentBlocks_detailsAndColors_BlockType {
              ...detailsAndColorsBlockType
            }
            ... on CraftContent_contentBlocks_variantConfigurator_BlockType {
              ...variantConfiguratorBlockType
            }
            ... on CraftContent_contentBlocks_embeddedPage_BlockType {
              ...embeddedPageBlockType
            }
            ... on CraftContent_contentBlocks_salesforceForm_BlockType {
              id
              ...salesforceFormSectionBlockType
            }
            ... on CraftContent_contentBlocks_onlineIncidentForm_BlockType {
              id
              ...onlineIncidentFormSectionBlockType
            }
          }
        }
      }
    }
  }
`

export default Page
